import Vue from 'vue'
import Vuex from 'vuex'
import lang from './modules/lang'
import entry from './modules/entry'
import storage from './modules/storage'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    lang,
    entry,
    storage,
  },
  plugins: [createPersistedState()],
})
